import { normalize } from "../common";
import { CONTAINER_NAME } from "../../../../utils/constant";
var getStorage = normalize.getStorage(function (args) {
  return wx.getStorage(args);
}, CONTAINER_NAME.WECHAT);
export default getStorage;